export const storeInLocalStorage = (item, key, value) => {
  let data = localStorage.getItem('stored');
  data = data ? JSON.parse(data) : {};
  data[key] = value;
  localStorage.setItem(item, JSON.stringify(data));
}